import { render, staticRenderFns } from "./PortInformations.vue?vue&type=template&id=45c111e6"
import script from "./PortInformations.vue?vue&type=script&lang=js"
export * from "./PortInformations.vue?vue&type=script&lang=js"
import style0 from "./PortInformations.vue?vue&type=style&index=0&id=45c111e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports